// Used this as a template: https://github.com/fabricjs/fabricjs.github.io/blob/main/src/content/demo/custom-filter-swap-color/colorSwapFilter.ts
import { filters } from 'fabric';

/**
 * SetColorFilter filter class
 * change all non-transparent pixels to the specified color
 */
export class SetColorFilter {
	static type = 'SetColorFilter';
	color: string;

	constructor(options: { color?: string } = {}) {
		this.color = options.color || 'rgba(255, 255, 255, 0.75)';
	}

	applyTo (fabricImage: any) {
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		const imgElement = fabricImage.getElement();

		canvas.width = imgElement.width;
		canvas.height = imgElement.height;

		// Draw the original image to our canvas
		ctx.drawImage(imgElement, 0, 0);

		// Get the image data
		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		const data = imageData.data;

		// Parse the color
		const [r, g, b, a] = this.color.match(/\d+(\.\d+)?/g)?.map(Number) || [255, 255, 255, 0.75];

		// Modify the pixel data
		for (let i = 0; i < data.length; i += 4) {
			const alpha = data[i + 3];
			if (alpha > 0) { // if not fully transparent
				data[i] = r;     // Red
				data[i + 1] = g; // Green
				data[i + 2] = b; // Blue
				data[i + 3] = Math.round(a * 255); // Alpha
			}
		}

		// Put the modified data back
		ctx.putImageData(imageData, 0, 0);

		// Update the fabric image with our modified canvas
		const newImgElement = new Image();
		newImgElement.src = canvas.toDataURL('image/png');

		// Wait for the image to load
		return new Promise((resolve) => {
			newImgElement.onload = () => {
				fabricImage.setElement(newImgElement);
				resolve(fabricImage);
			};
		});
	}
}
